import {
  ActionIcon,
  Avatar,
  Card,
  Group,
  Menu,
  Modal,
  SimpleGrid,
  Button,
  Stack,
  Text,
  ThemeIcon,
  Title,
  rem,
  Badge,
  Loader,
  Tooltip,
  TextInput
} from "@mantine/core";
import React, {
  useEffect,
  useState,
  useMemo,
  memo,
  useRef,
  useCallback,
} from "react";
import { DropDownSelect } from "./Startups";
import fetchApi from "../../Lib/api";
import {
  IconDots,
  IconUserPlus,
  IconUsers,
  IconUsersGroup,
  IconUserMinus,
  IconMessages,
  IconUser,
  IconMessageCircle,

} from "@tabler/icons-react";
import { useDisclosure } from "@mantine/hooks";
import Notification from "../../Lib/Notification";
import { countries, industries, skills } from "../../Onboarding/data";
import { useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import { useFilterStore } from "../../../stores/useFilterStore";
import useUserStore from "../../../stores/userStore";
import { Pagination } from '@mantine/core';

const MemberCard = ({
  
 name,
  role,
  avatar,
  email,
  github,
  linkedin,
  twitter,
  isFollowing,
  skills,
  experience,
  industries,
  location,
  first_name,
  last_name,
 users,
 id,
 setUsers,
 userId,
 setChatId,
 setSelectedUser,
 fetchData

}) => {


  return (
    <>
    <div data-slot="card" class="bg-white text-card-foreground flex flex-col gap-6 rounded-xl p-6 hover:shadow-lg transition-all duration-200 border  hover:border-gray-200 cursor-pointer" style={{ minHeight: "300px" }} onClick={(e) => {
      if (e.target.closest('button') || e.target.closest('a') || e.target.closest('[role="menu"]')) return;
      window.location.href = `/profile/user/${id}`;
    }}>
    <div class="flex flex-col space-y-4"> 
     <div class="flex items-start justify-between">
     <div class="flex items-center gap-3"> 
      <span
  data-slot="avatar"
  class="relative flex size-10 shrink-0 overflow-hidden rounded-full w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600"
>
  {avatar ? (
    <img
      src={avatar}
      alt={`${first_name} ${last_name}`}
      class="w-full h-full object-cover"
    />
  ) : (
    <span
      data-slot="avatar-fallback"
      class="flex size-full items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-blue-600 text-white font-medium text-sm"
    >
      {`${first_name?.[0] ?? ''}${last_name?.[0] ?? ''}`.toUpperCase()}
    </span>
  )}
</span>
   
     <div>
     <a href={`/profile/user/${id}`}>
      <h3 class="font-semibold text-gray-900 text-lg">{name}</h3>
      </a>
       <p class="text-base text-gray-500">{role}</p> <p class="text-sm text-gray-400 mt-1">{location}</p>
        </div>
         </div>
         <Menu
                  transitionProps={{ transition: "pop" }}
                  withArrow
                  position="left" 
                  offset={0}
                  withinPortal={false}
                >
                  <Menu.Target>
                    <ActionIcon variant="subtle" color="gray">
                      <IconDots
                        style={{ width: rem(24), height: rem(24) }}
                        stroke={1.8}
                      />
                    </ActionIcon>
                  </Menu.Target>
                  <Menu.Dropdown>
                    <Menu.Item
                      onClick={() => {
                        setSelectedUser(name);
                        fetchData();
                      }}
                      icon={
                        <IconUsers
                          style={{ width: rem(18), height: rem(18) }}
                          stroke={1.5}
                        />
                      }
                    >
                      Invite to a team
                    </Menu.Item>
                  </Menu.Dropdown>
                </Menu>
        
           </div> 
           <div class="flex gap-2">
            {industries.length>=1?
           <span data-slot="badge" class="inline-flex items-center justify-center rounded-md border font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-4 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden border-transparent [a&amp;]:hover:bg-secondary/90 text-sm px-3 py-1 bg-blue-100 text-blue-700">
            {`${industries[0]}${industries.length > 1 ? ` +${industries.length - 1}` : ''}`}
            </span>
            :''
}
            <span data-slot="badge" class="inline-flex items-center justify-center rounded-md border font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-4 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden border-transparent [a&amp;]:hover:bg-secondary/90 text-sm px-3 py-1 bg-gray-100 text-gray-700">
            { experience?`${experience}+years`:"0 years"}
             </span>
             </div> 
             {skills && skills.length>0&& (
             <div class="space-y-2">
              
              <p class="text-sm font-medium text-gray-600 uppercase tracking-wide">Skills</p>
              <div class="flex flex-wrap gap-2">
               
              
              {skills.slice(0, 4).map((skill) => (
            <span data-slot="badge" class="inline-flex items-center justify-center rounded-md border font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-4 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive overflow-hidden border-transparent [a&amp;]:hover:bg-secondary/90 text-sm px-3 py-1 bg-blue-50 text-blue-700 hover:bg-blue-100 transition-colors">
                {skill}
              </span>
            ))}
            {skills.length > 4 && (
              <span data-slot="badge" class="inline-flex items-center justify-center rounded-md border font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-4 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive overflow-hidden border-transparent [a&amp;]:hover:bg-secondary/90 text-sm px-3 py-1 bg-blue-50 text-blue-700 hover:bg-blue-100 transition-colors">
                +{skills.length - 4}
              </span>
            )}
                
                     </div> 
                     </div> 
             )}
                   
                     </div>
                     <div class="flex gap-2 pt-2 mt-auto"> 

                     {userId !== id && (
                          <MessageUser id={id} setChatId={setChatId} />
                     )
                        }
                          {userId !== id &&(
                         isFollowing?(
                          <button data-slot="button" class="inline-flex items-center justify-center whitespace-nowrap font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-5 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive rounded-md gap-1.5 px-3 has-[&gt;svg]:px-2.5 flex-1 h-8 text-sm bg-blue-600 hover:bg-blue-700 text-white"
                          onClick={() =>
                            handleFollowUnfollow(id, isFollowing, users, setUsers)
                          }>
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-user-minus w-3 h-3 mr-1.5" aria-hidden="true">
                          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                          <circle cx="9" cy="7" r="4"></circle>
                          <line x1="19" x2="19" y1="8" y2="14"></line>
                          <line x1="22" x2="16" y1="11" y2="11"></line>
                          </svg> 
                    Unfollow
                     </button>
                         )
                     :(
                     <button data-slot="button" class="inline-flex items-center justify-center whitespace-nowrap font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-5 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive rounded-md gap-1.5 px-3 has-[&gt;svg]:px-2.5 flex-1 h-8 text-sm bg-blue-600 hover:bg-blue-700 text-white"
                     onClick={() =>
                      handleFollowUnfollow(id, isFollowing, users, setUsers)
                    }>
                     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-user-plus w-3 h-3 mr-1.5" aria-hidden="true">
                     <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                     <circle cx="9" cy="7" r="4"></circle>
                     <line x1="19" x2="19" y1="8" y2="14"></line>
                     <line x1="22" x2="16" y1="11" y2="11"></line>
                     </svg> 
               Follow
                </button>
                          )
                       )}

                     </div>
                     </div>

  
    </>
  );
};



const experienceRanges = [
  { label: "All", value: "All" },
  { label: "Junior Level (0-2 years)", value: "Junior Level" },
  { label: "Mid-Level (2-4 years)", value: "Mid-Level" },
  { label: "Senior Level (4-6 years)", value: "Senior Level" },
  { label: "Expert Level (6+ years)", value: "Expert Level" },
];

const MembersFilters = ({ count }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const setFilterParam = useFilterStore((state) => state.setFilterParam);

  const memoizedSelectTypes = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    const keys = Array.from(searchParams.keys());

    return {
      location: { label: t("members.filters.location") },
      industry: {
        label: keys.includes("industries")
          ? searchParams.get("industries")
          : t("members.filters.industry"),
      },
      experience: {
        label: keys.includes("q")
          ? "Expert Level (6+ years)"
          : t("members.filters.experience"),
      },
      expert: {
        label: keys.includes("expert_in")
          ? searchParams.get("expert_in")
          : t("members.filters.expert"),
      },
      skills: {
        label: keys.includes("skills")
          ? searchParams.get("skills")
          : t("members.filters.skills"),
      },
    };
  }, [location.search]);

  // Memoize the selectData props for DropDownSelect components
  const memoizedSelectData = useMemo(
    () => ({
      countries: countries,
      industries: [{ label: "All", value: "All" }, ...industries],
      experienceRanges: experienceRanges,
      expertInObj: [{ label: "All", value: "All" }, ...skills],
      skillsObj: [{ label: "All", value: "All" }, ...skills],
    }),
    []
  );

  return (
    <section className="flex justify-center mb-8">
      <div className="w-full ">
      
          
          {/* The search bar is now in the header */}
          <Group className="grid sm:grid-cols-2 sm:gap-4 lg:grid-cols-5 lg:gap-4 w-full">
            <DropDownSelect
              filterKey="address_country_eq"
              selectType={memoizedSelectTypes.location}
              selectData={memoizedSelectData.countries}
              setFilterParams={(value) =>
                setFilterParam("address_country_eq", value)
              }
            />
            <DropDownSelect
              filterKey="industries"
              selectType={memoizedSelectTypes.industry}
              selectData={memoizedSelectData.industries}
              setFilterParams={(value) => setFilterParam("industries", value)}
            />
            <DropDownSelect
              filterKey="experience_range"
              selectType={memoizedSelectTypes.experience}
              selectData={memoizedSelectData.experienceRanges}
              setFilterParams={(value) =>
                setFilterParam("experience_range", value)
              }
            />
            <DropDownSelect
              filterKey="expert_in"
              selectType={memoizedSelectTypes.expert}
              selectData={memoizedSelectData.expertInObj}
              setFilterParams={(value) => setFilterParam("expert_in", value)}
            />
            <DropDownSelect
              filterKey="skills"
              selectType={memoizedSelectTypes.skills}
              selectData={memoizedSelectData.skillsObj}
              setFilterParams={(value) => setFilterParam("skills", value)}
            />
          </Group>
        
      </div>
    </section>
  );

};

const MemoMembersFilters = memo(MembersFilters);

const useUsers = (paramsObject, page) => {
  return useQuery({
    queryKey: ["users", JSON.stringify(paramsObject), page],
    queryFn: async () => {
      const params = new URLSearchParams();
      for (const key in paramsObject) {
        params.append(`q[${key}]`, paramsObject[key]);
      }
      const queryString = params.toString();
      console.log("Query:", queryString);

     const response = await fetchApi(`/api/users?${queryString}&page=${page}`, "GET");
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Failed to fetch users");
      }
      return await response.json();
    },
    retry: 1,
    staleTime: 5 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
  });
};

export default function Members() {
  // Use the filterParams from the global store
  const filterParams = useFilterStore((state) => state.filterParams);
  const location = useLocation();
  const searchParamsExecuted = useRef(false);
  const [users, setUsers] = React.useState([]);
  const [page,setPage]=React.useState(1);
 
  const [totalPages, setTotalPages] = useState(1);
  // Merge URL search params into the filterParams once
  const paramsObject = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    const updatedParams = { ...filterParams };

    if (!searchParamsExecuted.current) {
      searchParams.forEach((value, key) => {
        if (key !== "q") updatedParams[key] = value;
        else updatedParams["experience_range"] = "Expert Level";
      });
      searchParamsExecuted.current = true;
    }

    return updatedParams;
  }, [location.search, filterParams]);

  const { data, isLoading, isError, error } = useUsers(paramsObject, page);

  useEffect(() => {
    if (data) {
      setUsers(data.users || []);
    

      setTotalPages(data.total_pages || 1)
    }
  }, [data]);

  if (isLoading) {
    return (
      <Loader
        className="mx-auto mt-10"
        color="indigo"
        size="lg"
        variant="dots"
      />
    );
  }

  if (isError) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <>
     
      <section className="flex justify-center">
        <div className="w-full p-6">
    
          
            <Users users={users} setUsers={setUsers} page={page} setPage={setPage} totalPages={totalPages}/>
         
        </div>
      </section>
    </>
  );
}

export async function handleFollowUnfollow(
  userId,
  isFollowing,
  users,
  setUsers
) {
  try {
    const endpoint = !isFollowing
      ? `/users/${userId}/followings`
      : `/users/${userId}/followings/${userId}`;
    const method = !isFollowing ? "POST" : "DELETE";
    const response = await fetchApi(endpoint, method);

    if (response.ok) {
      const res = await response.json();
      if (Array.isArray(users)) {
        const updatedUsers = users.map((user) => {
          if (user.id === userId) {
            return { ...user, is_following: !isFollowing };
          }
          return user;
        });
        setUsers(updatedUsers);
      } else setUsers({ ...users, is_following: !isFollowing });
    } else {
      const { error } = await response.json();
      console.error(error);
    }
  } catch (error) {
    console.error("Error during follow/unfollow:", error);
  }
}

export function Users({ users, setUsers, page, setPage, totalPages }) {
  const [opened, { open, close }] = useDisclosure(false);
  const [chatId, setChatId] = useState(undefined);
  const [startups, setStartups] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [notification, setNotification] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [invitingId, setInvitingId] = useState(null);
 
  const {
    user: { id: userId },
  } = useUserStore((state) => state.user);

  console.log(userId)

  const fetchData = async () => {
    try {
      const response = await fetchApi("/user_startup_entities", "GET");

      if (response.ok) {
        const res = await response.json();
        // setNotification({ type: "success", content: msg });
        console.log(res);
        setStartups(res);
        open();
      } else {
        const msg = (await response.json()).error;
        // setNotification({ type: "failure", content: msg });
        console.error(msg);
      }
    } catch (error) {
      console.error("Error during password change:", error);
    } finally {
    }
  };

  const handleSubmit = async (id) => {
    try {
      setInvitingId(id);
      const response = await fetchApi("/invitations", "POST", {
        email: selectedUser,
        inviteable_type: "StartupEntity",
        inviteable_id: id,
      });

      if (response.ok) {
        const msg = (await response.json()).message;
        setNotification({ type: "success", content: msg });
        console.log("Invited successful!");
      } else {
        const msg = (await response.json()).error;
        setNotification({ type: "failure", content: msg });
        console.error("Invitation failed.");
      }
    } catch (error) {
      console.error("Error during Invitation", error);
    } finally {
      setInvitingId(null);
    }
  };
 

  return (
    <>
      {opened && (
        <Modal
          opened={opened}
          size="lg"
          onClose={close}
          centered
          title="Invite to a team"
        >
          <Stack spacing="md">
            {notification && <Notification {...notification} />}
            <Text size="sm" c="dimmed">
              Invite <b>{selectedUser}</b> to one of your projects.
            </Text>
            <TextInput
              placeholder="Search your projects..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.currentTarget.value)}
            />
            <div className="flow-root">
              <ul role="list" className="divide-y divide-gray-200 ">
                {startups
                  .filter((s) =>
                    !searchTerm
                      ? true
                      : (s.name || "").toLowerCase().includes(searchTerm.toLowerCase())
                  )
                  .map((startup) => (
                    <li className="py-2 list-none" key={startup.id}>
                      <div className="flex items-center space-x-4 p-3 bg-white border border-gray-200 rounded-lg hover:shadow-sm transition">
                        <div className="flex-shrink-0">
                          <Avatar
                            src={
                              startup.image?.url ||
                              "https://placehold.co/600x400?text=No Image"
                            }
                            mx="auto"
                            className="w-12 h-12 rounded-md"
                          />
                        </div>

                        <div className="flex-1 min-w-0">
                          <p className="text-base font-semibold text-gray-900 truncate">
                            {startup.name}
                          </p>
                          <p className="text-sm text-gray-500 line-clamp-2">
                            {startup.description}
                          </p>
                        </div>

                        <div className="ml-5 inline-flex items-center text-base font-semibold text-gray-900">
                          <Group gap={8} justify="flex-end">
                            <Button
                              size="xs"
                              variant="light"
                              onClick={() => handleSubmit(startup.id)}
                              loading={invitingId === startup.id}
                              disabled={invitingId === startup.id}
                            >
                              {invitingId === startup.id ? "Inviting..." : "Invite"}
                            </Button>
                          </Group>
                        </div>
                      </div>
                    </li>
                  ))}
              </ul>
            </div>
          </Stack>
        </Modal>
      )}
       <main class="flex-1 min-h-[calc(100vh-73px)] overflow-auto transition-all duration-300 ml-0">
       <div class="p-6">
       <div class="mb-6">
       <h1 class="text-2xl font-medium text-gray-900 mb-2">Team Members</h1>
       <p class="text-gray-600">Discover and connect with talented professionals in your network</p>
       </div>
      
      
            <MemoMembersFilters count={users.length} />
        
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        
       {users.map(
        ({
        
          first_name,
          last_name,
          job_title,
          avatar_url,
          email,
          github,
          linkedin,
          twitter,
          is_following,
          expert_in,
        industries,
          year_of_experience,
          address,
          id,
        
          
        }) => (
        
          <MemberCard
          
            name={`${first_name} ${last_name}`}
            role={job_title}
            avatar={avatar_url}
            email={email}
            github={github}
            linkedin={linkedin}
            twitter={twitter}
            isFollowing={is_following}
          industries={industries}
            experience={year_of_experience}
            skills={expert_in}
            location={address?.country||''}
            first_name={first_name}
            last_name={last_name}
            users={users}
            setUsers={setUsers}
            id={id}
            userId={userId}
            setChatId={setChatId}
            setSelectedUser={setSelectedUser}
            fetchData={fetchData}
          />
        )
        
      )} 

     
         </div>
         <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1rem' }}>
      <Pagination value={page} onChange={setPage} total={totalPages} size="xl" />
      </div>
         </div>
         </main>
         

    </>
  );
}

export function MessageUser({ id, setChatId, size = "xs", variant = "default", color, radius = "sm", fullWidth = false, leftIconSize = 16, compact = false }) {
  const handleSubmit = useCallback(async () => {
    try {
      const response = await fetchApi(`/conversations`, "POST", {
        conversation: {
          conversation_type: "direct",
          participant_ids: [id],
        },
      });

      if (response.ok) {
        const conversationData = await response.json();
        const conversationId = conversationData.id;

        if (conversationId) {
          if (setChatId) {
            setChatId(conversationId);
          }

          const targetUrl = `/dashboard/#/messages?conversationId=${conversationId}`;
          window.location.href = targetUrl;
        } else {
          console.error(
            "Received conversation data without an ID:",
            conversationData
          );
        }
      } else {
        const errorData = await response.json();
        const errorMessage = errorData.error || "Failed to start chat.";
        console.error(
          `Backend error starting chat with user ID ${id}: ${errorMessage}`,
          errorData
        );
      }
    } catch (error) {
      console.error(`Error during chat initiation with user ID ${id}:`, error);
    }
  }, [id, setChatId, fetchApi]);

  return (
    <button data-slot="button" class="inline-flex items-center justify-center whitespace-nowrap font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-5 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive border bg-background text-foreground hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 rounded-md gap-1.5 px-3 has-[&gt;svg]:px-2.5 flex-1 h-8 text-sm border-gray-200 hover:bg-gray-50"
    onClick={handleSubmit}>
                       
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-message-circle w-3 h-3 mr-1.5" aria-hidden="true">
    <path d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719">
      </path>
      </svg>
       Message
       </button>
  );
}
